import { TApiaComponent } from '../../../../types';

export function hasEvents(field: TApiaComponent) {
  return (
    (field.scriptEvents && field.scriptEvents.length > 0) ||
    (field.serverEvents &&
      field.serverEvents.filter((event) => event.evtName !== 'populate')
        .length > 0)
  );
}
